const SET_FARMS = (state, payload) => {
  state.farms = payload;
}

const SET_EDIT_FARM = (state, payload) => {
  const index = state.farms.findIndex(e => e.id === payload.id);
  if(index >= 0) state.farms.splice(index, 1, payload);
}

const SET_NEW_FARM = (state, payload) => {
  state.farms.unshift(payload);
}

export default {
  SET_FARMS,
  SET_EDIT_FARM,
  SET_NEW_FARM
}